export default function(ngModule) {
    ngModule.factory('CouponCode', function(BaseClass,$q, $http) {

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function CouponCode(attributes) {
            _.assign(this,attributes);

            if (this.coupon && this.coupon.guid) {
                this.coupon_id = this.coupon.guid;
            }
        }
        CouponCode.modelName = 'CouponCode';


        BaseClass.apply(CouponCode);

        CouponCode.validates({
            applies_to_count: {
                integer: true
            },
            usage_count: {
                integer: true
            }
        });

        CouponCode.configureApi('/coupon/:coupon_id/codes/:guid');

        CouponCode.prototype.toString = function() { return this.name; };

        return CouponCode;
    });
}
